<div class="card">
  <div class="card-content">
    <div class="page-header">
      <h4 translationEditableDirective="COMMERCIAL_LICENSE_MAPPINGS">
        {{ 'COMMERCIAL_LICENSE_MAPPINGS' | translate }}
      </h4>
    </div>

    <div class="page-toolbar">
      <div class="buttons">
        <a
          [routerLink]="['create']"
          class="button is-small is-info"
          translationEditableDirective="CREATE_COMMERCIAL_LICENSE_MAPPING"
          >{{ 'CREATE_COMMERCIAL_LICENSE_MAPPING' | translate }}</a
        >
      </div>
    </div>

    <app-table
      [isLoading]="isLoading"
      [rows]="state.get('data')"
      [hideFooter]="true"
      [columns]="columns"
    >
      <ng-template let-row="row" #actionsColumn>
        <div class="buttons">
          <div class="arrows">
            <button (click)="order(row.get('id'), 'up')">
              <i class="fas fa-chevron-up"></i>
            </button>
            <button (click)="order(row.get('id'), 'down')">
              <i class="fas fa-chevron-down"></i>
            </button>
          </div>
          <a
            [routerLink]="[row.get('id'), 'update']"
            class="button is-small"
            translationEditableDirective="UPDATE"
            >{{ 'UPDATE' | translate }}</a
          >
          <alert
            #deleteAlert
            (confirm)="deleteCommercialLicenseMapping(row.get('id'))"
            titleTrnKey="ARE_YOU_SURE"
            textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
          />
          <button
            class="button is-danger is-small"
            (click)="deleteAlert.fire()"
            translationEditableDirective="DELETE"
          >
            {{ 'DELETE' | translate }}
          </button>
        </div>
      </ng-template>
    </app-table>
  </div>
</div>
